import React, {useRef, useState, useEffect} from 'react';

import styles from './SearchBar.module.scss';
import IconSearch from '../../assets/images/btn_search_v2.png';
import IconClear from '../../assets/images/btn_home.png';

const MIN_LENGTH_TO_SEARCH = 2;

const SearchBar = ({ config, filterOffers, resetOffersFilter }) => {
    const [inputValueSearch, setInputValueSearch] = useState('');
    let debounceTimeout = useRef(null);
    const [isSearched, setIsSearched] = useState(false);

    const onChangeSearch = (value) => {
        // do something if needed
        setInputValueSearch(value);

        clearTimeout(debounceTimeout.current);
        // showing all offers after deleting the search input automaticly 
        if(isSearched){
            debounceTimeout.current = setTimeout(() => {
                if (!value.length ) {
                    resetSearch();
                }
            }, 500);
        }
    }

    const searchAndFilterOffers = () => {
        filterOffers(inputValueSearch);
        setIsSearched(true);
    }

    const searchOffers = (event) => {
        if ((event.key === 'Enter') && (inputValueSearch.length >= MIN_LENGTH_TO_SEARCH)) {
            searchAndFilterOffers();
        }
    }

    const resetSearch = () => {
        setInputValueSearch('');
        resetOffersFilter();
        setIsSearched(false);
    }

    useEffect(() => {
        return () => {
             clearTimeout(debounceTimeout.current);
        };
    }, []);

    return (
        <div className={styles.searchBarWrapper}>
            <div className={styles.searchClear} onClick={resetSearch}>
                <img className={styles.iconClear} src={IconClear} alt={'img'} />
            </div>
            <div className={styles.searchField}>
                <input
                    placeholder={config.searchBarPlaceholder}
                    onChange={(e) => {
                        const val = (e.target.value);
                        onChangeSearch(val);
                    }}
                    value={inputValueSearch}
                    onKeyDown={searchOffers}
                />
            </div>
            <div className={styles.searchFind}>
                <img className={styles.iconSearch} src={IconSearch} alt={'img'} onClick={searchAndFilterOffers} />
            </div>
        </div>
    );
};

export default SearchBar;